module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"TRAIN_DIMENSIONS":"TRAIN DIMENSIONS","EVAL_DIMENSIONS":"EVAL DIMENSIONS"},"fr":{"TRAIN_DIMENSIONS":"DIMENSIONS ENTRAINEMENT","EVAL_DIMENSIONS":"DIMENSIONS EVALUATION"}}')
  delete Component.options._Ctor
}
